module.exports = __webpack_public_path__ + "img/DM.d2225e70.png";